import classNames from 'classnames'
import type { CharacterCounterProps } from './character-counter.interface'
import classes from './character-counter.module.scss'

export function CharacterCounter({ count, max, className }: CharacterCounterProps) {
  return (
    <span
      className={classNames(classes.counter, className, { [classes.over]: count > max })}
      aria-live="polite"
      data-testid="character-counter"
    >
      {`${count}/${max}`}
    </span>
  )
}
